"use client";

import { glassBorderRingElementProps, type GlassBorderRingProps } from "./glass-border-ring";

export type { GlassBorderRingProps } from "./glass-border-ring";

export function GlassBorderRing(props: GlassBorderRingProps) {
	const ringProps = glassBorderRingElementProps(props);
	return <div {...ringProps} />;
}
